import { memo } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";

import { reorderedShiftManagerListSelector } from "../../reducers/shiftManagerManagement/selectors";

import useWindowDimensions from "../../utils/useWindowDimensions";

import ShiftManagerList from "./ShfitManagerList";
import { View } from "../Base";
import { ShiftManagerViews } from "./ShiftManagerViews";
import { ShiftManagerSortBar } from "./ShiftManagerSortBar";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  list: {
    overflow: "auto",
    marginRight: "-14px",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
});

export const ShiftManagerDetail = memo(() => {
  const styles = useStyles();
  const shiftManagers = useSelector(reorderedShiftManagerListSelector);
  const { height: windowHeight } = useWindowDimensions();

  return (
    <div className={styles.container}>
      <ShiftManagerViews />
      <ShiftManagerSortBar />
      <View className={styles.list}>
        <ShiftManagerList
          shiftManagers={shiftManagers}
          height={windowHeight - 254}
        />
      </View>
    </div>
  );
});

export default ShiftManagerDetail;
